import Vue from 'vue'

const state = {
  bookDetail: {},
};

const mutations = {
  'SET_BOOK_DETAIL' (state, detail) {
    state.bookDetail = detail;
  },
  'SET_BOOK_PURCHASED' (state, hasPurchased) {
    state.bookDetail.has_purchased = hasPurchased;
  },
};

const actions = {
  setBookDetail: ({commit}, detail) => {
    commit('SET_BOOK_DETAIL', detail);
  },
  setPurchased: ({commit}, hasPurchased) => {
    commit('SET_BOOK_PURCHASED', hasPurchased);
  }
};

const getters = {
  bookDetail: state => {
    return state.bookDetail;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/bookdetail.js